import { styled } from '@superset-ui/core';
import React, { useState } from 'react';

interface Props {
    title: string;
    subTitle: string;
    iconLabel: string;
    labelIcon: any;
    thumbnailUrl: any;
    placeholderImage: any;
}

const StyledDiv = styled.div`
    display: flex;
    .thumbnail-card {
        border: 1px solid #D6DEEB;
        border-radius: 8px;
        padding: 1rem;
        display: inline-flex;
        flex-direction: column;
        gap: 1em;
        min-width: 19rem;
        height: 17rem;
        cursor: pointer;
    }

    .thumbnail-cardText {
        display: flex;
        flex-direction: column;
        gap: .2em;
    }

    .thumbnail-image-row {
        display: flex;
        width: 100%;
        height: 70%;
        align-items: center;
        justify-content: center;
    }

    .thumbnail-imgBox {
        display: flex;
        height: 100%;
        max-width: 14rem;
        img {
            width: 100%;
            height: 100%;
        }
    }

    .thumbnail-iconRow {
        display: flex;
        flex-direction: row;
        gap: .5em;
    }

    .thumbnail-iconLabel {
        font-weight: 400;
        font-size: .7rem;
        line-height: .8rem;
        color: #A7A9BC;
    }

    .thumbnail-title {
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.1rem;
        overflow: hidden;
        white-space: nowrap;
    }

    .thumbnail-subTitle {
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.1rem;
        color: #6B6C7E;
    }
`;

const Card = (props: Props) => {
    const [ loading, setLoading ] = useState<boolean>(true);
    const [ isHiddenImage, hideImage ] = useState<boolean>(false);

    return (
        <StyledDiv>
            <div className='thumbnail-card'>
                <div className='thumbnail-image-row'>
                    <div className='thumbnail-imgBox'>
                        {loading && <img src={props.placeholderImage} alt="" />}
                        {!isHiddenImage && <img src={props.thumbnailUrl} alt=""
                            onLoad={() => setLoading(false)}
                            onError={() => hideImage(true)}/>}
                    </div>
                </div>

                <div className='thumbnail-cardText'>
                    <div className='thumbnail-iconRow'>
                        <img src={props.labelIcon} alt="" />
                        <div className='thumbnail-iconLabel'>
                            {props.iconLabel}
                        </div>
                    </div>
                    <div className='thumbnail-title'>
                        {props.title}
                    </div>
                    <div className='thumbnail-subTitle'>
                        Modified {props.subTitle}
                    </div>
                </div>
            </div>
        </StyledDiv>
    );
};

export default Card;